import { en } from "@/plugins/locale/en";
import { ko } from "@/plugins/locale/ko";

export default {
  en,
  ko,
};
